// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4798":"fe8eb4c70bdfb6ea","9890":"7378d35bb04e911e"}[chunkId] + ".js";
};